module.exports = __webpack_public_path__ + "img/show-password.7907e4b.svg";